module.exports = __webpack_public_path__ + "img/magento-support-security.b0a72306.jpeg";